import ResetPasswordContainer from "components/modules/ForgotPassword/ResetPassword";
import React from "react";


const ResetPassword = () => {
  return (
    <div>
      <ResetPasswordContainer />
    </div>
  );
};

export default ResetPassword;
